import React from 'react';
import { FirstPageWrapper } from '~/components';

export const Browser = () => {
  return <FirstPageWrapper />;
};
